import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { take, catchError } from 'rxjs/operators';
import { StockOperation } from '../../models/stock-operation.model';
import { StockService } from '../../services/stock.service';
import { StockOperationValidatorService } from '../../validators/stock-operation-validator.service';
import { OPERATION_TRANSFER } from '../../partials/stock-operation-form/stock-operation-form.component';

@Component({
    selector: 'app-stock-transfer',
    templateUrl: './stock-transfer.component.html',
    styleUrls: ['./stock-transfer.component.scss'],
    standalone: false
})
export class StockTransferComponent {

  operation: StockOperation = new StockOperation();

  operationType: string = OPERATION_TRANSFER;

  isError: boolean = false;
  isServerError: boolean = false;
  serverErrorMessage: string = '';

  constructor(private stockOperationValidator: StockOperationValidatorService,
    private stockService: StockService,
    private router: Router) { }

  /**
   * The whole batch goes up in one request because the backend runs it in a single
   * transaction, so stock is never in both locations or neither.
   */
  onSubmit() {

    this.isError = false;
    this.isServerError = false;
    this.serverErrorMessage = '';

    if (this.stockOperationValidator.isValid(this.operation, true)) {
      this.stockService.transfer(this.operation)
      .pipe(take(1))
      .pipe(catchError((e) => {
        this.isServerError = true;
        this.serverErrorMessage = e.error && e.error.message ? e.error.message : '';
        return e;
      }))
      .subscribe((levels) => {
        this.router.navigate(['/warehousing/stock-movement-labels'], { state: { levels } });
      })
    } else {
      this.isError = true;
    }
  }
}
